import { render } from "./pencilbutton.vue?vue&type=template&id=5da682fa"
import script from "./pencilbutton.vue?vue&type=script&lang=js"
export * from "./pencilbutton.vue?vue&type=script&lang=js"

import "./pencilbutton.vue?vue&type=style&index=0&id=5da682fa&lang=css"

import exportComponent from "/home/runner/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__